import React from "react";
import { Route } from "react-router-dom";

import {ProductsUIProvider} from "../../contexts/ProductsUIContext";
import {ProductsContainer} from '../../components/containers/ProductsContainer';
import {ProductDetailModal} from "../../components/modules/ProductDetailModal";

import {URLs} from "../../../utils/routes";

export function ProductsPage({ history }) {
  const productsUIEvents = {
    openProductDetailDialog: (id) => {
      history.push(`${URLs.SERVICES_PRODUCTS}/${id}`);
    },
    goToCreateLink: (e, prodId) => {
      e.stopPropagation();
      history.push(`${URLs.SERVICES_LINKS_CREATE}${prodId ? '?prodId='+prodId : ''}`);
    },
  };

  return (
    <ProductsUIProvider productsUIEvents={productsUIEvents}>
      <ProductsContainer />

      <Route path={URLs.SERVICES_PRODUCT_DETAIL}>
        {({ history, match }) => match ? (
          <ProductDetailModal
            show={true}
            prodId={match.params.prodId}
            onHide={() => history.goBack()}
          />
        ) : null}
      </Route>
    </ProductsUIProvider>
  );
}
